/**
 * MAGNiTT access roles and their respective ids
 */
const userRoles = {
    development: {
        directory_access: 8,
        limited_directory_access: 46,
    },
    production: {
        directory_access: 8,
        limited_directory_access: 52,
    }
}

export const MAGNITT_ACCESS_ROLES = userRoles[process.env.NODE_ENV];
